import Vue from 'vue'
import api from '@/api'
import router from '@/router'
import appLocalStorage from '@/appLocalStorage';

let store = new Vue({
  data: {
    accessToken: '',
    operador: {},
    preferencias: {},
    datos: {
      id_instalacion_seleccionada: null,
      id_empresa_inquilina_seleccionada: null,
    },
  },
  computed: {
    operadorLogado () {
      return (this.accessToken != '');
    }
  },
  methods: {
    INICIAR_SESION (email, password) {
      return new Promise ( (resolve, reject) => {
        api.iniciarSesion (email, password)
          .then ((respuesta) => {
            this.recuperar_sesion (respuesta.data.accessToken)
              .then (() => {
                resolve ();
              })
              .catch ((e) => {
                reject (e);
              });
          })
          .catch ((e) => {
            reject (e);
          });
      });
    },

    RECUPERAR_SESION () {
      const accessTokenAlmacenado = appLocalStorage.get ('accessToken');
      return this.recuperar_sesion (accessTokenAlmacenado);
    },

    CERRAR_SESION () {
      return new Promise ( (resolve, reject) => {
        api.cerrarSesion ()
          .then (() => {
            this.borrar_access_token ();
            Vue.prototype.$global.inicializar(); // debemos inicializar los objetos que van a ser reusados!! (o bien, recargar la pagina)
            resolve();
          })
          .catch ((e) => {
            console.log (`Error al cerrar la sesión: ${e}`);
            reject (e);
          });
      });
    },

    establecer_access_token (accessToken) {
      this.accessToken = accessToken;
      appLocalStorage.set ('accessToken', accessToken);
      api.establecerAccessToken (accessToken);
    },

    borrar_access_token () {
      this.accessToken = '';
      appLocalStorage.remove (['accessToken']);
      api.eliminarAccessToken ();
    },

    recuperar_sesion (accessToken) {
      return new Promise ( (resolve, reject) => {
        if (accessToken) {
          this.establecer_access_token (accessToken);
          this.obtener_datos_sesion ()
            .then (() => {
              resolve();
            })
            .catch ((e) => {
              this.borrar_access_token ();
              reject (e);
            });
        } else {
          this.borrar_access_token ();
          reject ("Token de acceso no válido");
        }
      });
    },

    obtener_datos_sesion () {
      return new Promise ( (resolve, reject) => {
        api.obtenerDatosSesion ()
          .then ((respuesta) => {
            this.operador = respuesta.data.operador;
            this.preferencias = respuesta.data.preferencias || {};
            Object.keys (this.datos).forEach ((propiedad) => {
              if (respuesta.data.datos [propiedad]) {
                this.datos [propiedad] = respuesta.data.datos [propiedad];
              }
            });
            //console.log (JSON.stringify (this.$data));
            resolve ();
          })
          .catch ((e) => {
            reject (e);
          });
      });
    },

    leer_preferencia  (nombre, valorPorDefecto, categoria1 = null, categoria2 = null, categoria3 = null) {
      let clave = nombre;
      if (categoria3) clave = categoria3 + '.' + clave;
      if (categoria2) clave = categoria2 + '.' + clave;
      if (categoria1) clave = categoria1 + '.' + clave;

      //console.log(clave, valorPorDefecto);
      return this.preferencias [clave] || valorPorDefecto;
    },

    guardar_preferencia  (nombre, valor, valorPorDefecto, categoria1 = null, categoria2 = null, categoria3 = null) {
      let clave = nombre;
      if (categoria3) clave = categoria3 + '.' + clave;
      if (categoria2) clave = categoria2 + '.' + clave;
      if (categoria1) clave = categoria1 + '.' + clave;

      let preferenciasAnterior = JSON.stringify (this.preferencias);

      valor = JSON.parse (JSON.stringify (valor)); // nos aseguramos de copiar Arrays y Objetos
      if (JSON.stringify (valor) !== JSON.stringify (valorPorDefecto))
        this.$set (this.preferencias, clave, valor);
      else
        this.$delete (this.preferencias, clave);

      if (JSON.stringify (this.preferencias) != preferenciasAnterior)
        api.guardarPreferenciasOperador (this.preferencias);
    }
  }
})

Vue.prototype.$store = store;

// Añadimos un "interceptor" para tratar los errores
api.instanciaAxios.interceptors.response.use (
  function (response) {
    return response
  },
  function (error) {
    if (401 === error.response.status) { // error "No autorizado" estando logado
        if (store.operadorLogado) {
          // borramos el token de sesion (cerramos la sesion de manera local) y nos vamos a la home page
          store.borrar_access_token ();
          router.push ('/')
          alert ('La sesion ya no es válida. Por favor, ingrese de nuevo')
        } else {
          // error al hacer el login (por ejemplo, usuario o contraseña incorrecto)
          return Promise.reject(error);
        }
    } else {
      if (error.config && error.config._opciones && error.config._opciones.controlErrores === false) // si hemos decidido gestionar los errores particularmente, devolvemos el error
        return Promise.reject(error);

      Vue.prototype.$cuadroDeDialogo.mostrarEx ({
        propsDialog: {
          maxWidth: "40%"
        },
        titulo: {
          estilo: "background: #FFB74D",
          texto: "Error",
          icono: { nombre: "mdi-close-octagon", props: { large: true } }
        },
        cuerpo: {
          mensajes: [
            { texto: "Se ha producido un error al realizar la petición:" },
            { texto: error, estilo: "font-family: monospace" },
            { texto: error.response.data, estilo: "font-size: 8pt; white-space: pre-wrap;" }
          ],
          props: { class: "mt-2" }
        },
        acciones: {
          botones: [ { texto: "Aceptar", props: { color: "#EF6C00", text: true } } ]
        }
      });
      return Promise.reject(error);
    }
  }
)

export default store